import React from 'react';
import { concatImageS3 } from "../../../../../js/shared/utils";

const myFlights = concatImageS3("account/empty-flights.svg");


const MyPassengersHasError = () => {
	return (
		<div className="my-passengers--has-errors">
			<p className="lead">
				Há algo de errado com essa pesquisa, verifique as datas e tente novamente.
			</p>
			<img src={myFlights} alt="" className="img-responsive"/>
		</div>
	);
};

export default MyPassengersHasError;